import React from 'react';
import Card from '../ui/Card';
import StorageIcon from '@mui/icons-material/Storage';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PsychologyIcon from '@mui/icons-material/Psychology';
import './Benefits.css';

const elements = [
  {
    icon: <StorageIcon />,
    title: 'Data',
    description: 'Every objective, key result and supporting metric in one shared view. Updated continuously. Visible to everyone who needs it.',
    detail: "When data is visible to all, something shifts. People ask better questions. They add context. They surface the insight from last week's customer call that never made it into a report. Shared visibility turns individual knowledge into organizational knowledge.",
  },
  {
    icon: <AccountTreeIcon />,
    title: 'Processes',
    description: 'Two guided workflows take your organization from strategy planning all the way through to execution. Step by step. Nothing skipped. Nothing left to chance.',
    detail: 'When the process is structured and guided, the uncomfortable steps get taken too. The ones that usually get postponed because everyone assumes someone else is handling them. Structure is what turns good intentions into coordinated action.',
  },
  {
    icon: <PsychologyIcon />,
    title: "People's knowledge",
    description: "Every function holds context that data alone cannot capture. The pattern your analyst spotted. The reason behind the number your manager knows but has not written down. The insight that explains why this quarter looks the way it does. Furudio gives that knowledge a place to live. A structured space where the people who hold it can contribute what matters, at the moment it is relevant, so it becomes part of the shared picture rather than disappearing when the meeting ends.",
    detail: 'When knowledge has a place to live, it stops leaving with the people who hold it. It becomes something the whole organization can build on, return to, and act from.',
  },
];

const Benefits: React.FC = () => {
  return (
    <section className="benefits section" id="elements">
      <div className="container">
        <div className="benefits__header">
          <p className="benefits__subtitle text-center">
            Where data, processes, and people's knowledge finally meet.
          </p>
        </div>
        <div className="benefits__grid benefits__grid--three">
          {elements.map((element, index) => (
            <Card key={index} className="benefits__card benefits__card--large">
              <div className="benefits__icon">{element.icon}</div>
              <h3 className="benefits__card-title">{element.title}</h3>
              <p className="benefits__card-description">{element.description}</p>
              <p className="benefits__card-detail">{element.detail}</p>
            </Card>
          ))}
        </div>
        <p className="benefits__closing text-center">
          When these three come together, the chain from operational signal to strategic decision becomes visible for the first time.
        </p>
      </div>
    </section>
  );
};

export default Benefits;
